import React, { FC } from 'react';

import CustomHits from 'common/Filters/CustomHits';
import CustomResultsHandler from 'common/Filters/CustomResultsHandler';

import { MediaLandingArticlesProps } from './models';

import './MediaLandingArticles.scss';

const MediaLandingArticles: FC<MediaLandingArticlesProps> = ({
  noResultsText,
  lang,
  readingTimeText,
  writtenByText,
}) => (
  <CustomResultsHandler noResultsText={noResultsText}>
    <CustomHits
      loadMoreText=""
      isGridLayout
      lang={lang}
      hideLoadMoreButton
      readingTimeText={readingTimeText}
      writtenByText={writtenByText}
    />
  </CustomResultsHandler>
);

export default MediaLandingArticles;
